import UploadedPhoto from '@/model/UploadedPhoto';
import { OperatorFunction, of, EMPTY } from 'rxjs';
import ImageProcessingError from '@/model/ImageProcessingError';
import { catchError, map } from 'rxjs/operators';

export default function convertErrors<T>(
    photo: UploadedPhoto,
    operatorName = 'unknown operator',
): OperatorFunction<T, T | ImageProcessingError<T>> {
    return (source) =>
      source.pipe(
        catchError((err) =>
          of(err).pipe(
            map((mappedErr) => new ImageProcessingError(photo, mappedErr, EMPTY, operatorName)),
          ),
        ),
      );
  }
